import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class vignetteStylesheetsView_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title icon i-summary"  data-bind="text: name">Vignette Stylesheet</h3>
                    <div class="w-btn">
                        <!-- ko if: isBrandOwner() -->
                            <button data-bind="event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Stylesheet</button>
                        <!-- /ko -->
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Status</label>
                            <span data-bind="text: idStatus() == 2 ? 'Completed' : 'Draft'"></span>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Slug</label>
                            <span data-bind="text: slug"></span>
                        </div>
                    </div>
                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Shared CSS</strong>
                        <pre style="white-space: pre-wrap; background: #1e1e1e; color: #ddd; padding: 1rem; border-radius: 4px;" data-bind="text: css"></pre>
                    </div>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {
    }

    protected getTemplateName(): string {
        return "vignetteStylesheetsView_template";
    }

    protected buildViewModel(): any {
        const self = this;

        return {
            brand: ko.observable(""),
            id: ko.observable(""),
            name: ko.observable(""),
            slug: ko.observable(""),
            css: ko.observable(""),
            idStatus: ko.observable(1),
            isBrandOwner: ko.pureComputed(() => self.getIsBrandOwner()),
            brandOwner: ko.observable(null),
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            onClickEdit: function (data, event) {
                self.onClickEdit(data.id());
            }
        }
    }

    public getIsBrandOwner = (): boolean => {
        const vm = this.getTemplateViewModel();
        return (vm.brandOwner() && vm.brand()) ? vm.brandOwner().id == vm.brand() : false;
    }

    public onClickCancel() {
        this.caller.cancel();
    }

    public onClickEdit(id) {
        this.caller.edit(id);
    }

    public setBrand(brand): void {
        this.getTemplateViewModel().brand(brand);
    }

    public setStylesheet(stylesheet): void {
        this.getTemplateViewModel().id(stylesheet.id);
        this.getTemplateViewModel().name(stylesheet.name);
        this.getTemplateViewModel().slug(stylesheet.slug);
        this.getTemplateViewModel().css(stylesheet.css || '');
        this.getTemplateViewModel().idStatus(stylesheet.idStatus);
        this.getTemplateViewModel().brandOwner(stylesheet.brandOwner);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignetteStylesheetsView_template.ts